import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineThumbsDownIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 2H6.27a3 3 0 0 0-2.95 2.46l-1.27 7A3.0001 3.0001 0 0 0 5 15h4.56L9 16.43A4.13 4.13 0 0 0 12.89 22a1.0004 1.0004 0 0 0 .91-.59L16.65 15H19a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm-4 11.79-2.72 6.12a2.13 2.13 0 0 1-1.38-2.78l.53-1.43a2.0007 2.0007 0 0 0-.2294-1.8387A2.0003 2.0003 0 0 0 9.56 13H5a1.001 1.001 0 0 1-.77-.36.9994.9994 0 0 1-.23-.82l1.27-7a1 1 0 0 1 1-.82H15v9.79ZM20 12a1.0001 1.0001 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1v7Z"/>
  </SvgIcon>
}

export default LineThumbsDownIcon
